module.exports = __webpack_public_path__ + "static/media/create-animation-icon.cc03d604.svg";